<template>
  <div id="app">
    <h1>SmartPot App</h1>
    <SensorReadings
      :moisture_value="moisture_value"
      :humidity_perc_value="humidity_perc_value"
      :temperature_c_value="temperature_c_value"
    > </SensorReadings>
    <div v-if="last_updated" class="last-updated">
      Last Updated {{ last_updated }}
    </div>
    
  </div>
</template>

<script>
import SensorReadings from './components/SensorReadings.vue'

export default {
  name: 'App',
  components: {
    SensorReadings
  },
  data() {
    return {
      readings: null,
      param_names: ['moisture', 'temperature_c', 'humidity_perc'],
      // param_name: "moisture",
      // param_value: null,
      moisture_value: null,
      temperature_c_value: null,
      humidity_perc_value: null,
      last_updated: null
    }
  },
  mounted() {
    this.fetchData();

    setInterval(function () {
      this.fetchData();
    }.bind(this), 30 * 1000); 
  },
  methods: {
    fetchData() {
      console.log("Fetching data..");
      
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({"param_names":this.param_names});

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch("https://mankoo-smartpot-api.herokuapp.com/v2/read", requestOptions)
        .then(response => response.text())
        .then((result) => {
          this.readings = JSON.parse(result).readings;
          var reading_ts_str = JSON.parse(result).readings[0].reading_ts;
          this.last_updated = new Date(`${reading_ts_str}Z`).toString();

          // for(var i = 0, size = this.readings.length; i < size ; i++){
          //   const reading = this.readings[i];
          for(const reading of this.readings) {
            if(reading.param_name == 'moisture'){
              this.moisture_value = reading.param_value;
            } else if (reading.param_name == 'humidity_perc'){
              this.humidity_perc_value = reading.param_value;
            } else if (reading.param_name == 'temperature_c'){
              this.temperature_c_value = reading.param_value;
            }
          }

        })
        .catch(error => console.log('error', error));

    }

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.last-updated {
  margin-top: 20px;
}
</style>
